module.exports = __webpack_public_path__ + "static/media/Whatsapp_Guide_iOS_Chin.3a24164e.docx";